import { EquipmentListEnum } from "@oysterhr/schema"

export const sortedEquipmentList = (() => {
  const providedEquipmentOrder = [
    EquipmentListEnum.LaptopComputer,
    EquipmentListEnum.MobilePhone,
    EquipmentListEnum.ComputerMonitor,
    EquipmentListEnum.Printer,
    EquipmentListEnum.Keyboard,
    EquipmentListEnum.Headset,
    EquipmentListEnum.Mouse,
  ]
  return Object.values(EquipmentListEnum).sort(
    (a, b) => providedEquipmentOrder.indexOf(a) - providedEquipmentOrder.indexOf(b),
  )
})()
